import { propClassName } from '@/styles/404';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils';

export interface Http404HeadlineProps extends ComponentProps<'h1'> {
  colors?: ClassNameProp;
  size?: ClassNameProp;
  variant?: ClassNameProp;
}

export const Http404HeadlineComponent: Component<Http404HeadlineProps> = ({
  children,
  className,
  colors,
  size,
  variant,
  ...props
}) => {
  const colorsClassName = propClassName('headline_colors', colors);
  const sizeClassName = propClassName('headline_size', size);
  const variantClassName = propClassName('headline_variant', variant);
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return (
    <h1 className={componentClassName} {...props}>
      {children}
    </h1>
  );
};
